import api from "./api";

export const getProvinces = async () => {
  return api
    .get({
      endpoint: "/territory/provinces",
      port: process.env.REACT_APP_PORT_TERRITORY,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
